import classNames from 'classnames'
import moment from 'moment'

import { useGetDashUnitStats } from '@apps-common/apis/portal/dash'
import { PageSubtitle } from '@apps-common/components/common/portal-title'
import { UNIT_STATUS_PENDING_CANCELLATION } from '@apps-common/config/unit-filter'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { AUTH_CLAIMS, useAuthorizationCheckAccess } from '@apps-common/lib'
import {
  DEFAULT_MANAGEMENT_UNITS_FILTER_STORE_PROPS,
  DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
  useManagementUnitsFilterStore,
  usePortalUnitsFilterStore
} from '@apps-common/stores'
import { ROUTE_UNITS } from '@apps-radionet-portal-root/src/config/private-routes'

export const TotalPendingCancellationKpiCard = () => {
  const { navigateRoot } = useNavigation()
  const hasManagementAccess = useAuthorizationCheckAccess({
    roles: AUTH_CLAIMS.managementAdmin.roles,
    scopes: AUTH_CLAIMS.managementAdmin.scopes
  })
  const { setTempState: setPortalTempState } = usePortalUnitsFilterStore()
  const { setTempState: setManagementTempState } = useManagementUnitsFilterStore()
  const { isLoading, data } = useGetDashUnitStats({})

  return (
    <button
      type='button'
      className='bg-surface border border-border w-full h-[100%] rounded-3xl overflow-hidden ring-1 ring-warning'
      onClick={() => {
        if (hasManagementAccess) {
          setManagementTempState({
            ...DEFAULT_MANAGEMENT_UNITS_FILTER_STORE_PROPS,
            status: UNIT_STATUS_PENDING_CANCELLATION.value as string
          })
          navigateRoot({ routeUrl: ROUTE_UNITS.buildPath(), route: ROUTE_UNITS })
        } else {
          setPortalTempState({
            ...DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
            status: UNIT_STATUS_PENDING_CANCELLATION.value as string
          })
          navigateRoot({ routeUrl: ROUTE_UNITS.buildPath(), route: ROUTE_UNITS })
        }
      }}
    >
      <div className='relative z-[1] pt-4 pb-3 px-4 md:p-8 md:pb-7 flex flex-col h-[100%]'>
        <PageSubtitle classes='text-accent-secondary-content text-right leading-[0.8em]'>
          <span className='text-[0.9em]'>Pending Cancel</span>
        </PageSubtitle>
        <div className='grow flex items-center justify-center'>
          <div
            className={classNames(
              'min-w-[70px] px-4 py-2 bg-surface-2 rounded-full text-text flex items-center justify-center',
              (isLoading || !data) && 'animate-pulse'
            )}
          >
            <h4 className='text-[1.5rem] sm:text-[1.95rem] md:text-[2.5rem] jost-medium'>
              {!isLoading && data ? new Intl.NumberFormat().format(data?.totalPendingCancellation || 0) : <span>&nbsp;</span>}
            </h4>
          </div>
        </div>
        <div className='flex'>
          <div
            className={classNames(
              'bg-surface-2 rounded-full px-2 md:py-1 jost-light inline w-auto text-[0.7em] md:text-[0.8em] text-text',
              (isLoading || !data) && 'animate-pulse'
            )}
          >
            <span className={classNames((isLoading || !data) && 'opacity-0')}>
              As at {moment.utc(data?.timestamp).local().format('DD/MM/YYYY')}
            </span>
          </div>
        </div>
      </div>
      {/* <div className='absolute w-full h-full top-0 left-0 bg-secondary/70 rounded-3xl z-[0]' /> */}
    </button>
  )
}
